if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

if (typeof Shopify.theme.jsAddToCart === 'undefined') {
  Shopify.theme.jsAddToCart = {
    addedToCartIcon: '<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.85327 7.56052C3.75977 7.65452 3.63227 7.70702 3.49977 7.70702C3.36727 7.70702 3.23977 7.65452 3.14627 7.56052L0.323266 4.73702C0.0302656 4.44402 0.0302656 3.96902 0.323266 3.67652L0.676766 3.32302C0.969766 3.03002 1.44427 3.03002 1.73727 3.32302L3.49977 5.08552L8.26227 0.323022C8.55527 0.0300215 9.03027 0.0300215 9.32277 0.323022L9.67627 0.676522C9.96927 0.969522 9.96927 1.44452 9.67627 1.73702L3.85327 7.56052Z" fill="white"/></svg>',
    addToCartListener: function addToCartListener(event, addToCartBtn) {
      let wasClicked = event.target;
      let targetBtn = wasClicked.closest('button');
      let addedToCartBannerSubscriptions = document.querySelector('.added-to-cart-banner');

      if (!addToCartBtn.disabled) {
        if (wasClicked === addToCartBtn || targetBtn === addToCartBtn) {
          if (Shopify.theme.settings.cart_action == 'ajaxcart') {
            event.preventDefault();
            document.dispatchEvent(new Event('cart:updated'));
            wasClicked.setAttribute('disabled', true);
            const targetForm = wasClicked.closest('form');

            if (targetForm !== null) {
              const formData = new FormData(targetForm);

              if (targetForm['properties[engraving-B]']) {
                formData.append('engraving-B', targetForm['properties[engraving-B]'].value);
              }

              if (targetForm['properties[engraving-F]']) {
                formData.append('engraving-F', targetForm['properties[engraving-F]'].value);
              } // check all cart items


              $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function (cart) {
                  const items = cart.items;
                  let existSubscription = false;
                  items.forEach(item => {
                    // active var if exist subscriptions at cart
                    if (item.selling_plan_allocation) {
                      existSubscription = true;
                    }
                  });
                  let quickAddMobileModal = wasClicked.closest('.mobile-product-modal-form');

                  if (quickAddMobileModal) {
                    wasClicked.closest('[data-add-to-cart]').classList.add('added');
                    wasClicked.closest('[data-add-to-cart]').innerHTML = '<span>Added</span>' + Shopify.theme.jsAddToCart.addedToCartIcon;
                    setTimeout(function () {
                      quickAddMobileModal.querySelector('.js-close-product-form-mobile').click();
                    }, 300);
                  } // add hidden element with class to be manage if exist


                  if (existSubscription) {
                    let hiddenSubscriptionMessage = document.createElement('p');
                    hiddenSubscriptionMessage.className = 'subscription-plan-activated';
                    document.body.appendChild(hiddenSubscriptionMessage);
                  } // fire event cart:updated


                  document.dispatchEvent(new CustomEvent('cart:updated'));
                }
              }); // if adding a subscription plan

              let selling_plan_selector = document.querySelector('[name="selling_plan"]');

              if (selling_plan_selector !== null && selling_plan_selector.value != '') {
                var _document$querySelect, _document$querySelect2;

                let selling_plan = document.querySelector('[name="selling_plan"]').value;
                let quantity = document.querySelector('.quantity-box__input').value;
                let variant_id = ((_document$querySelect = document.querySelector('select[data-productid]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value) || ((_document$querySelect2 = document.querySelector('input[name="id"]')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value); // Add product using ajax and force reload to the first page with a paramenter
                // if its first subscription on the cart

                function addItemToCart(variant_id, qty, selling_plan) {
                  data = {
                    id: variant_id,
                    quantity: qty,
                    selling_plan: selling_plan
                  };
                  jQuery.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function () {},
                    complete: function () {
                      Shopify.theme.jsAjaxCart.onCartChange();
                      Shopify.theme.jsCartCounter.update();

                      if (addedToCartBannerSubscriptions) {
                        document.body.classList.add('subscription-active');
                        addedToCartBannerSubscriptions.classList.add('visible');
                        setTimeout(() => {
                          addedToCartBannerSubscriptions.classList.remove('visible');
                          document.body.classList.remove('subscription-active');
                        }, 1000);
                      } else {
                        Shopify.theme.jsAjaxCart.openCart();
                      }
                    }
                  });
                }

                addItemToCart(variant_id, quantity, selling_plan);
              } else {
                const http = new XMLHttpRequest(),
                      url = window.Shopify.routes.root + 'cart/add.js';
                http.open('POST', url, true); //http.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

                http.onreadystatechange = function () {
                  if (http.readyState == 4 && http.status == 200) {
                    // add any animations or class changes for completion. re-enable button if disabled.
                    wasClicked.removeAttribute('disabled');
                    Shopify.theme.jsAjaxCart.onCartChange();
                    Shopify.theme.jsCartCounter.update();

                    if (addedToCartBannerSubscriptions) {
                      document.body.classList.add('subscription-active');
                      addedToCartBannerSubscriptions.classList.add('visible');
                      setTimeout(() => {
                        addedToCartBannerSubscriptions.classList.remove('visible');
                        document.body.classList.remove('subscription-active');
                      }, 1000);
                    } else {
                      Shopify.theme.jsAjaxCart.openCart();
                    }
                  }
                };

                http.send(formData);
              }
            }
          }
        }
      }

      return false;
    },
    listenAll: function listenAll() {
      let addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
      addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.addEventListener('click', function (event) {
          Shopify.theme.jsAddToCart.addToCartListener(event, addToCartBtn);
        });
      });
    },
    listenOne: function listenOne(element) {
      let addToCartBtns = element.querySelectorAll('[data-add-to-cart]');
      addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.addEventListener('click', function (event) {
          Shopify.theme.jsAddToCart.addToCartListener(event, addToCartBtn);
        });
      });
    }
  };
} // Important - Add to cart functionality is launched by boost, on collection pages.


(() => {
  const productPage = document.querySelector('body[class*="product"]');

  if (productPage) {
    Shopify.theme.jsAddToCart.listenAll();
  }
})();
